import axiosInstance from './api'
import {
	fixtureFetchStudentApplicationDocuments,
	shouldUseApplicationFlowFixtures,
} from 'fixtures/applicationFlowFixtures'

export const fetchStudentApplicationDocuments = async studentId => {
	if (shouldUseApplicationFlowFixtures()) {
		return fixtureFetchStudentApplicationDocuments(studentId)
	}

	const { data } = await axiosInstance.get(
		`/counseling/students/${encodeURIComponent(studentId)}/application-documents`,
	)
	return data
}

export const downloadStudentApplicationDocument = async (studentId, fileId) => {
	const res = await axiosInstance.get(
		`/counseling/students/${encodeURIComponent(studentId)}/application-documents/files/${encodeURIComponent(fileId)}/download`,
		{ responseType: 'blob' },
	)
	return res.data
}

export const uploadStudentApplicationDocument = async (studentId, requirementId, file) => {
	const form = new FormData()
	form.append('file', file)
	const { data } = await axiosInstance.post(
		`/counseling/students/${encodeURIComponent(studentId)}/application-documents/${encodeURIComponent(requirementId)}/upload`,
		form,
		{ headers: { 'Content-Type': 'multipart/form-data' } },
	)
	return data
}

export const nudgeStudentApplicationDocument = async (studentId, requirementId) => {
	const { data } = await axiosInstance.post(
		`/counseling/students/${encodeURIComponent(studentId)}/application-documents/nudge`,
		{ requirementId },
	)
	return data
}

// Ask the backend to fetch this course's document requirements from Perplexity.
// Takes an application target because that is what the counselor UI holds; the
// backend resolves it to a course.
export const refreshStudentApplicationDocuments = async (studentId, applicationTargetId) => {
	const { data } = await axiosInstance.post(
		`/counseling/students/${encodeURIComponent(studentId)}/application-documents/refresh`,
		{ applicationTargetId },
	)
	return data
}

export const fetchStudentApplicationDocumentsStatus = async (studentId, applicationTargetId) => {
	const { data } = await axiosInstance.get(
		`/counseling/students/${encodeURIComponent(studentId)}/application-documents/status`,
		{ params: { applicationTargetId } },
	)
	return data
}
